import { Box } from '../../Box/Box.js';
import styled from 'styled-components';

var RadioButtonStyled = /*#__PURE__*/styled(Box).withConfig({
  displayName: "RadioButtonstyled__RadioButtonStyled",
  componentId: "sc-1cxijc0-0"
})(function (props) {
  return {
    width: '100%',
    height: '100%',
    '&::after': {
      position: 'absolute',
      width: '10px',
      height: '10px',
      'border-radius': '50%',
      background: props.$color,
      /* stylelint-disable-next-line string-quotes */
      content: '""',
      display: props.$checked ? 'block' : 'none',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      margin: 'auto'
    }
  };
});

export { RadioButtonStyled };
//# sourceMappingURL=RadioButton.styled.js.map
